import { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

function AccordionItem({ title, children, isOpen, onClick }) {
  return (
    <div className="accordion-item-custom">
      <button
        className={`accordion-header-custom ${isOpen ? 'active' : ''}`}
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
      </button>
      <div className={`accordion-body-custom ${isOpen ? 'open' : ''}`}>
        <div className="accordion-content-custom">
          {children}
        </div>
      </div>
    </div>
  )
}

function AccidentesTrabajo() {
    const title =  'Accidentes de trabajo e in itinere'
    const [openIndex, setOpenIndex] = useState(null)
    const toggle = (index) => {
      setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <>
            <Header/>
            <main id="main">
                {/* ======= Breadcrumbs ======= */}
                <section id="breadcrumbs" className="breadcrumbs">
                  <div className="container">
                    <ol>
                      <li><a href="/">Inicio</a></li>
                      <li>{title}</li>
                    </ol>
                    {/*h2>{title}</h2*/}
                    <div className="row">
                      <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
                        <img src="assets/img/accidente.png" className="img-fluid" alt="accidentes de trabajo 1" style={{'padding': '5%'}}/>
                        <img id="img-2" src="assets/img/accidente2.png" className="img-fluid" alt="accidentes de trabajo 2" style={{'padding': '5%'}}/>
                      </div>
                      <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
                        <h3>{title}</h3>
                        <p className="fst-italic justified-text">
                          ¿Sufriste un accidente en tu trabajo o yendo/volviendo del mismo? <strong>Sabemos lo difícil que es ese momento</strong>, y estamos para ayudarte a obtener la indemnización que te corresponde.
                        </p>
                        <p className="justified-text">En <strong>MFV ABOGADOS</strong> nos especializamos en la representación de trabajadores accidentados. Trabajamos con el <strong>baremo de incapacidades actualizado (Decreto 549/2025)</strong> junto a nuestros médicos legistas para obtener el mayor porcentaje de incapacidad física y psíquica de acuerdo a tu lesión.</p>

                        <div style={{margin: '20px 0'}}>
                          <AccordionItem title="¿Qué es un accidente de trabajo?" isOpen={openIndex === 0} onClick={() => toggle(0)}>
                            <p>Es cualquier evento inesperado que ocurre durante el ejercicio de tu actividad laboral y que resulta en un daño o lesión. Puede suceder en cualquier entorno: una oficina, una fábrica, un sitio de construcción, en la vía pública realizando tareas, entre otros. Incluye caídas, lesiones por maquinaria, golpes, cortaduras y cualquier otro suceso imprevisto que cause daño físico o mental.</p>
                          </AccordionItem>
                          <AccordionItem title="¿Qué es un accidente in itinere?" isOpen={openIndex === 1} onClick={() => toggle(1)}>
                            <p>Es el accidente que ocurre en el trayecto directo entre tu casa y tu lugar de trabajo, o viceversa. Para que sea reconocido por tu ART, no debés haberte desviado de tu recorrido habitual. Es importante que recuerdes el trayecto realizado, ya que puede ser requerido tanto por la aseguradora como por el juez en caso de juicio.</p>
                          </AccordionItem>
                        </div>

                        <h4>¿Qué hacemos por vos?</h4>
                        <ul>
                          <li><i className="bi bi-check-circle" /> <strong>Reclamo administrativo</strong> ante las Comisiones Médicas de la SRT por tu porcentaje de incapacidad.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Reclamo judicial contra tu ART</strong> para obtener el mayor porcentaje de incapacidad.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Rechazo de denuncia</strong> — si tu ART rechazó tu siniestro, reclamamos ante la SRT.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Alta médica prematura</strong> — si te dieron el alta antes de tiempo y seguís con dolor o limitaciones.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Daño psicológico</strong> — reclamamos la incapacidad psíquica que las ART suelen minimizar o desconocer.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Despido post-accidente</strong> — si te despidieron después de un accidente laboral, tenés derechos adicionales.</li>
                        </ul>

                        <p className="justified-text"><strong>No dejes pasar el tiempo.</strong> Cuanto antes inicies el reclamo, mejor protegidos quedan tus derechos.</p>
                        <p className="justified-text">Por consultas o inquietudes podés escribirnos al <a className='black-link' href="https://wa.me/+5491124089830?text=Hola%2C%20tuve%20un%20accidente%20de%20trabajo%20y%20necesito%20asesoramiento">11-2408-9830.</a></p>
                        <br/>
                        <a href="https://wa.me/+5491124089830?text=Hola%2C%20tuve%20un%20accidente%20de%20trabajo%20y%20necesito%20asesoramiento" className="cta-button">Hablemos de tu caso</a>
                      </div>
                    </div>
                  </div>
                </section>{/* End Breadcrumbs */}
            </main>
            <Footer/>

            <style>{`
              .accordion-item-custom {
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                margin-bottom: 12px;
                overflow: hidden;
                transition: box-shadow 0.3s ease;
              }
              .accordion-item-custom:hover {
                box-shadow: 0 2px 12px rgba(0,0,0,0.08);
              }
              .accordion-header-custom {
                width: 100%;
                padding: 18px 24px;
                background: #fff;
                border: none;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 1.05rem;
                font-weight: 600;
                color: #2c2c2c;
                transition: background 0.2s ease;
              }
              .accordion-header-custom:hover {
                background: #fafafa;
              }
              .accordion-header-custom.active {
                background: #b41e1e;
                color: #fff;
              }
              .accordion-header-custom.active i {
                color: #fff;
              }
              .accordion-header-custom i {
                font-size: 1.1rem;
                color: #b41e1e;
                transition: transform 0.3s ease;
              }
              .accordion-body-custom {
                max-height: 0;
                overflow: hidden;
                transition: max-height 0.4s ease;
              }
              .accordion-body-custom.open {
                max-height: 500px;
              }
              .accordion-content-custom {
                padding: 20px 24px;
                border-top: 1px solid #eee;
              }
              .accordion-content-custom p {
                font-size: 0.98rem;
                color: #555;
                line-height: 1.7;
                text-align: justify;
                margin-bottom: 10px;
              }
            `}</style>
        </>
    );
}

export default AccidentesTrabajo;
